<template>
  <div class="plugin-settings">
    <plugin-item-list-overview
        :isActive.sync="isActive"
        :pluginName="pluginName"
        :pluginDesc="pluginDesc"
        :pluginImgName="pluginImgName"
        :handle="handle"
        :can-edit="editPrivilege"
        has-modal-settings=true
        @open-modal="openModal"
        @update-is-active="updateActivationState"
    ></plugin-item-list-overview>
    <b-modal
        id="plugin-chatGPT"
        content-class="plugin-modal"
        size="lg"
        centered
        ok-only
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        @ok="handleOk"
    >
      <template v-slot:modal-title>
        <h3>{{ $t('settings.plugins.chatGPT.modalTitle') }}</h3>
      </template>
      <b-row class="my-4">
        <b-col cols="12" offset-sm="1" sm="10">
          <p v-html="$t('settings.plugins.chatGPT.modalDesc')"></p>
        </b-col>
      </b-row>
      <component
        v-for="(configItem, index) in pluginFieldConfig"
        :key="index"
        :is="configItem.fieldType"
        :handle="configItem.handle"
        :label="configItem.title"
        :desc="configItem.desc"
        :value-from-db="settingsData[configItem.handle]"
        @update-field="updateSettingValue($event, configItem.handle)"
      />
      <template v-slot:modal-footer="{ ok }">
        <b-button
          @click="ok()"
          block
          class="p-3"
        >
          {{ $t('button.ok') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CheckboxRow from '@/components/helper/CheckboxRow.vue';
import PluginItemListOverview from '@/components/settings/plugins/PluginItemListOverview.vue';
import InputRow from '@/components/helper/InputRow.vue';

export default {
  name: 'PluginGatedContent',
  components: {
    PluginItemListOverview,
    CheckboxRow,
    InputRow,
  },
  props: {
    pluginData: {
      type: Object,
      default: null,
    },
    editPrivilege: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      handle: 'plugin_chatGPT',
      pluginName: this.$t('settings.plugins.chatGPT.name'),
      pluginDesc: this.$t('settings.plugins.chatGPT.desc'),
      pluginImgName: 'chatGPT.jpg',
      pluginFieldConfig: [
        {
          title: this.$t('settings.plugins.chatGPT.apiKeyLabel'),
          desc: this.$t('settings.plugins.chatGPT.apiKeyDesc'),
          fieldType: 'InputRow',
          handle: 'api_key',
        },
        {
          title: this.$t('settings.plugins.chatGPT.modelLabel'),
          desc: this.$t('settings.plugins.chatGPT.modelDesc'),
          fieldType: 'InputRow',
          handle: 'model',
        },
        {
          title: this.$t('settings.plugins.chatGPT.maxTokensLabel'),
          desc: this.$t('settings.plugins.chatGPT.maxTokensDesc'),
          fieldType: 'InputRow',
          handle: 'max_tokens',
        },
        {
          title: this.$t('settings.plugins.chatGPT.temperatureLabel'),
          desc: this.$t('settings.plugins.chatGPT.temperatureDesc'),
          fieldType: 'InputRow',
          handle: 'temperature',
        },
      ],
      isActive: false,
      settingsData: {
        api_key: null,
        model: 'text-davinci-003',
        max_tokens: '256',
        temperature: '0',
      },
    };
  },
  created() {
    if (this.pluginData) {
      this.isActive = (this.pluginData && 'enabled' in this.pluginData)
        ? this.pluginData.enabled
        : this.isActive;
      this.settingsData = (
        this.pluginData && 'settings' in this.pluginData && Object.keys(this.pluginData.settings).length !== 0
      )
        ? { ...this.pluginData.settings }
        : { ...this.settingsData };
    }
  },
  methods: {
    openModal() {
      this.$bvModal.show('plugin-chatGPT');
    },
    updateSettingValue(value, handle) {
      if (handle in this.settingsData) {
        this.settingsData[handle] = value;
      }
    },
    handleOk() {
      this.updatePluginData();
    },
    updateActivationState(state) {
      this.isActive = state;
      if (state === true) {
        this.$bvModal.show('plugin-chatGPT');
      }
      this.updatePluginData();
    },
    updateCheckbox(event) {
      this.settingsData.anomymizeIp = event;
    },
    updatePluginData() {
      const pluginDataObject = {
        handle: this.handle,
        enabled: this.isActive,
        settings: this.settingsData,
      };
      this.$emit('update-plugin-data', pluginDataObject);
    },
  },
};
</script>
